<template>
  <section class="section" id="configs-panel">
    <div class="container">
      <b-loading
        :is-full-page="true"
        :active="isLoading"
        :can-cancel="false"
      ></b-loading>

      <store-header :storeBeingManaged="storeBeingManaged" />

      <store-address :storeBeingManaged="storeBeingManaged" />

      <div
        v-if="
          permissions.manageStoreStatus &&
            !storeBeingManaged.storeInfo.vendingsOnly
        "
      >
        <hr class="separator" />
        <store-status />
      </div>

      <div>
        <hr class="separator" />

        <span class="subtitle"> {{ $t("settings.generatePixPayment") }}: </span>
        <br />
        <button
          class="button is-primary"
          style="margin-top: 5px;"
          @click="openGouPayment"
        >
          {{ $t("settings.generate") }}
        </button>
      </div>

      <div
        v-if="
          permissions.manageCashback &&
            !storeBeingManaged.storeInfo.vendingsOnly
        "
      >
        <hr class="separator" />
        <cashback />
      </div>

      <div v-if="permissions.manageCoupon">
        <hr class="separator" />
        <coupon />
      </div>

      <div v-if="!storeBeingManaged.storeInfo.vendingsOnly">
        <hr class="separator" />
        <promotional-image />
      </div>

      <div
        v-if="
          permissions.managePromotionsOptin &&
            isPromotionsOptInActive &&
            !storeBeingManaged.storeInfo.vendingsOnly &&
            ['oniiFranchise', 'mq'].includes(companyInfo.contract)
        "
      >
        <hr class="separator" />
        <promotions />
      </div>

      <div v-if="role === 'merchant'">
        <hr class="separator" />
        <notifications />
      </div>

      <div
        v-if="
          storeBeingManaged.accessDevices &&
            storeBeingManaged.accessDevices.length &&
            permissions.manageAccessControl &&
            !storeBeingManaged.storeInfo.vendingsOnly
        "
      >
        <hr class="separator" />
        <access-control />
      </div>

      <!-- <div v-if="permissions.manageMealVouchers">
        <hr class="separator" />
        <vouchers />
      </div> -->

      <div
        v-if="
          permissions.managePayments &&
            !storeBeingManaged.storeInfo.vendingsOnly
        "
      >
        <hr class="separator" />
        <payments />
      </div>

      <div
        v-if="
          permissions.manageTaxes &&
            storeBeingManaged.address.countryCode === 'PT'
        "
      >
        <hr class="separator" />
        <taxes />
      </div>

      <div
        v-if="
          permissions.manageNotFoundProductsActions &&
            !storeBeingManaged.storeInfo.vendingsOnly
        "
      >
        <hr class="separator" />
        <product-not-found />
      </div>

      <div
        v-if="
          permissions.manageCatalogActions &&
            !storeBeingManaged.storeInfo.vendingsOnly
        "
      >
        <hr class="separator" />
        <catalog />
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";
import storeHeader from "../common/StoreHeader";
import storeAddress from "./StoreAddress";
import storeStatus from "./StoreStatus";
import cashback from "./cashback/Cashback";
import promotions from "./Promotions";
// import vouchers from "./Vouchers";
import notifications from "./Notifications";
import catalog from "./Catalog";
import accessControl from "./AccessControl";
import productNotFound from "./ProductNotFound";
import payments from "./Payments";
import taxes from "./Taxes";
import coupon from "./coupon/Coupon";
import promotionalImage from "./promotional-image/PromotionalImage";

export default {
  mixins: [common],

  components: {
    storeHeader,
    storeAddress,
    storeStatus,
    cashback,
    promotions,
    // vouchers,
    notifications,
    catalog,
    accessControl,
    productNotFound,
    payments,
    taxes,
    coupon,
    promotionalImage
  },

  data() {
    return {
      isLoading: false
    };
  },

  methods: {
    openGouPayment() {
      let url = `https://gou.onii.app?s=${this.storeBeingManaged.uuid}`;
      window.open(url, "_blank");
    }
  },

  computed: {
    ...mapGetters([
      "storeBeingManaged",
      "permissions",
      "role",
      "isPromotionsOptInActive",
      "companyInfo"
    ])
  },

  mounted() {
    console.log(this.companyInfo);
  }
};
</script>

<style scoped>
#configs-panel {
  margin-top: 3rem;
  min-height: 94vh;
  padding: 2rem 1rem;
  background-color: hsl(0, 0%, 96%);
}
.separator {
  background-color: #e5e5e5;
}
</style>
